import { createIconSet } from '@expo/vector-icons';
import glyphMap from '~/../assets/fonts/Fontisto/unicodesMap.json';
export default createIconSet(glyphMap, 'Fontisto', require('~/../assets/fonts/Fontisto/Fontisto.ttf'));
